export const Data = "Data";
// export const PatientDetails = "PatientDetails";
// export const StateList = "StateList";
export const CurrentLocation = "CurrentLocation";
export const CurrentLocationId = "currentLocationId";
export const CurrentDoctorId = "CurrentDoctorId";
export const providerData = "providerData";
export const ProviderData = "ProviderData";
export const CurrentProviderData = "CurrentProviderData";
export const Template = "Template";
export const BaseUrl = "BaseUrl";
export const TokenInfo = "TokenInfo";
export const CurrentUser = "CurrentUser";
export const CurrentID = "CurrentID";
export const MaskEmail = "MaskEmail";
export const propsHistory = "propsHistory";
export const AssignedTemplates = "AssignedTemplates";
export const UserProfile = "UserProfile";
export const ParentPageCalledOtherDocuments = "ParentPageCalledOtherDocuments";
export const CommonServiceToken = "CommonServiceToken";
export const VisitTypeData = "VisitTypeData";

export const StatesData = "StatesData";

export const CaseType = "CaseType";
export const UpdatePatientCaseType = "UpdatePatientCaseType";
export const Doctor = "Doctor";
export const Speciality = "Speciality";
export const ReferringOffice = "ReferringOffice";
export const CompanySpeciality = "CompanySpeciality";
export const Location = "Location";
export const TransportData = "TransportData";
export const CaseStatus = "CaseStatus";
export const VisitCaseType = "VisitCaseType";
export const UnSentCaseTypeOption = "UnSentCaseTypeOption";
export const AttorneyList = "AttorneyList";
export const AttorneyData = "AttorneyData";
export const LanguageData = "LanguageData";
export const VisitCaseStatus = "VisitCaseStatus";
export const ReferringOfficeList = "ReferringOfficeList";
export const ReferringOfficeData = "ReferringOfficeData";

export const InsuranceList = "InsuranceList";
export const InsuranceResult = "InsuranceResult";
export const InsuranceListProviderCalendar = "InsuranceListProviderCalendar";

export const AdjusterList = "AdjusterList";
export const AdjusterData = "AdjusterData";

export const AccessList = "AccessList";
export const IsPdfLoadedSucessfully = "IsPdfLoadedSucessfully";

export const IsSelected = "IsSelected";

export const CalendarType = "CalendarType";

export const DoctorCalendarData = "DoctorCalendar"
export const ProviderCalendarData = "ProviderCalendar"
export const VerboseNote = "VerboseNote"
export const ExceptionMessage = {
  UnAuthMessage: "Authorization has been denied for this request",
};

export const AttorneyDataMissingInformation = "AttorneyDataMissingInformation";
export const InsuranceDataMissingInformation = "InsuranceDataMissingInformation";
export const CaseTypeMissingInformation = "CaseTypeMissingInformation";
export const ImplicitDoctorSignatureOnNote = "ImplicitDoctorSignatureOnNote";

export const ExceriseElbowSubType = {
  WristCurves: "Wrist Curves",
  ReverseWristCurves: "Reverse Wrist Curves",
  HammerRotations: "Hammer Rotations",
  SupportedBicepCurl: "Supported Bicep Curl",
  TowelCrush: "Towel Crush",
};

export const EprescriptionCredsDoctorPreProd = {
  partnerName: "Greenbills",
  name: "demo",
  password: "demo",
  productName: "NewScript Software",
  productVersion: "V1.0",
  user: "LicensedPrescriber",
  role: "doctor",
  requestedPage: "compose",
  country: "US"
}

export const EprescriptionCredsStaffPreProd = {
  partnerName: "Greenbills",
  name: "demo",
  password: "demo",
  productName: "NewScript Software",
  productVersion: "V1.0",
  user: "Staff",
  role: "nurse",
  requestedPage: "compose",
  country: "US"
}

export const EprescriptionCredsDoctorProd = {
  partnerName: "Greenbills",
  name: "d90ce1e5-8360-4ec9-8f8f-ce35d2e1497d",
  password: "0c8069f5-a59e-46cc-8795-e44c2b718f36",
  productName: "NewScript Software",
  productVersion: "V1.0",
  user: "LicensedPrescriber",
  role: "doctor",
  requestedPage: "compose",
  country: "US"
}

export const EprescriptionCredsStaffProd = {
  partnerName: "Greenbills",
  name: "d90ce1e5-8360-4ec9-8f8f-ce35d2e1497d",
  password: "0c8069f5-a59e-46cc-8795-e44c2b718f36",
  productName: "NewScript Software",
  productVersion: "V1.0",
  user: "Staff",
  role: "nurse",
  requestedPage: "compose",
  country: "US"
}

export const ExceriseFootAnkleSubType = {
  WallCalfStretch: "Wall Calf Stretch",
  StepUpArchExtensions: "Step-Up Arch Extensions",
  BalletRaises: "Ballet Raises",
  ReachAndStretch: "Reach And Stretch",
  MonkeyFootTowelLifts: "Monkey Foot Towel Lifts",
};

export const ExceriseHipSubType = {
  PigeonStretch: "Pigeon Stretch",
  SingleLegHipCircles: "Single-Leg Hip Circles",
  SingleLegGluteKicks: "Single-Leg Glute Kicks (Donkey Kicks)",
  PliéSquats: "Plié Squats",
  MonsterWalks: "Monster Walks",
};

export const ExceriseKneeSubType = {
  StraightLegRaises: "Straight Leg Raises",
  StandingQuadStretch: "Standing Quad Stretch",
  Squats: "Squats",
  LateralLegRaises: "Lateral Leg Raises",
  BackLunges: "Back Lunges",
};

export const ExceriseSholudersSubType = {
  BarrelHug: "Barrel Hug",
  LateralRaises: "Lateral Raises",
  StandingUprightRows: "Standing Upright Rows",
  ShoulderIYTs: "Shoulder I-Y-T’s",
  ExternalBandRotation: "External Band Rotation",
};

export const NodeTypeList = {
  All: "All",
  Activity: "Activity",
  General: "General",
  Calendar: "Calendar",
  Popup: "Popup",
  Provider: "Provider",
};

export const EmitterVariable = {
  Location_Changed_Appointment: "Location_Changed_Appointment",
  Location_Changed_Patient: "Location_Changed_Patient",
  Location_Changed_Calendar: "Location_Changed_Calendar",
  Location_Changed_DocSearch: "Location_Changed_DocSearch",
  OnChangeBaseURL: "OnChangeBaseURL",
  Dismiss_Notification: "Dismiss_Notification",
  sessionExpired: "sessionExpired",
  Location_Changed_Global: "Location_Changed_Global"
};

export const SystemResolution = {
  isDesktopHD: "isDesktopHD",
  isError: "isError",
};

export const LabelName = {
  Appointment: "Appointment",
  Calendar: "Calendar",
  Patient: "Patient",
  OtherDocuments: "OtherDocuments",
  OtherDocumentsTemplates: "OtherDocumentsTemplates",
  DocumentManger: "DocumentManger",
  UnArchive: "UnArchive",
  DocumentSearch: "DocumentSearch",
  isLoadedFirstTime: "isLoadedFirstTime",
  CallingPage: "CallingPage",
  AddUpdatePatient: "AddUpdatePatient",
  ProviderCalendar: "ProviderCalendar",
  Dashboard: "Dashboard",
  PM2_4: "PM2_4",
  VisitReport: "VisitReport",
  UnSentNF2Report: "UnSentNF2Report",
  MessageReport: "MessageReport",
  TransportationReport: "TransportationReport",
  DailyScheduleReport: "DailyScheduleReport",
  PatientAbsenteeReport: "PatientAbsenteeReport",
  UnArchiveVisits: "UnArchiveVisits",
  AssignedReports: "AssignedReports",
  PatientVisitSummaryReport: "PatientVisitSummaryReport",

};

export const ProviderCalendarConstant = {
  DayView: "Day",
  WeekView: "Week",
  MonthView: "Month",
  AgendaView: "Agenda",
  SettingView: "Settings",
  StartTimeRole: "StartTimeRole",
  EndTimeRole: "EndTimeRole",
  SlotTimeRole: "SlotTimeRole",
  MultipleDoctorsVisit: "MultipleDoctorsVisit",
  MultiplePatientsVisit: "MultiplePatientsVisit",
  Sunday: "Sunday",
  Monday: "Monday",
  Tuesday: "Tuesday",
  Wednesday: "Wednesday",
  Thursday: "Thursday",
  Friday: "Friday",
  Saturday: "Saturday",
  CalendarDate: "CalendarDate",
  ShowBusinessDaysSwitch: "ShowBusinessDaysSwitch",
  BusinessDaysCurrentProvider: "BusinessDaysCurrentProvider",
};

export const FrontDeskDashboard = {
  MissingInformationType: {
    MISSING_INSURANCE_COMPANY: "MISSING_INSURANCE_COMPANY",
    MISSING_ATTORNEY: "MISSING_ATTORNEY",
    MISSING_CLAIM_NUMBER: "MISSING_CLAIM_NUMBER",
    MISSING_REPORT_NUMBER: "MISSING_REPORT_NUMBER",
    MISSING_POLICY_HOLDER: "MISSING_POLICY_HOLDER",
    MISSING_UNSENTNF2: "MISSING_UNSENTNF2",
  },
  AppointmentType: {
    NO_SHOW: "No Show",
    COMPLETED: "Completed",
    SCHEDULED: "Scheduled",
  },
  TodaysReminderPopupShow: "TodaysReminderPopupShow",
};

export const PrescriptionHistoryStatus = {
  Incomplete: 1,
  Queued: 2,
  Verify: 3,
  Error: 4,
  NewRx: 5,
  CancelRx: 6,
  Other: 7,
};

export const StatusNameConstant = {
  Incomplete: "Incomplete",
  Queued: "Queued",
  Verify: "Verify",
  Error: "Error",
  NewRx: "NewRx",
  CancelRx: "CancelRx",
  Other: "Other",
};

export const DrugConstant = {
  DrugCollection: "DrugCollection",
  DrugCollectionObject: "DrugCollectionObject",
  Drug: "Drug",
  Compound: "Compound",
  CompoundDrug: "CompoundDrug",
};

export const PharmacyConstant = {
  SelectedPharmacy: "SelectedPharmacy",
};

export const FinalConstant = {
  finalSrc: "finalSrc",
};

export const SortingLabel = {
  VisitDate: "VisitDate",
  CaseNo: "CaseNo",
  PatientName: "PatientName",
  InsuranceName: "InsuranceName",
  Status: "Status",
};

export const UserAcessLabel = {
  SingOnFile: "SingOnFile",
  FaxService: "Fax Service",
  TeleVisit: "TeleVisit",
  EPrescribe: "EPrescribe",
  OfficeCalendar: "OfficeCalendar",
  DoctorCalendar: "DoctorCalendar",
  NursePractitionerSign: "NursePractitionerSign",
  DefaultSingOnFile: "DefaultSingOnFile",
  IsAssignedReport: "IsAssignedReport",
  FunctionalCapacityTest: "FunctionalCapacityTest"
};

export const AppointmentSearch = {
  TypeOfVisit: "TypeOfVisit",
  FromDate: "FromDate",
  ToDate: "ToDate",
  SearchParameter: "SearchParameter",
  DateRange: "DateRange",
  MedicalNotes: "ModicalNotes",
  isCalendarInputChange: "isCalendarInputChange",
  locationType: "OfficeId",
  SearchResultList: "SearchResultList",
  totalNoRowsReturn: "totalNoRowsReturn",
  IsNewVisit: "IsNewVisit",
  isLocationChanges: "isLocationChanges",
  isFinalized: "isFinalized",
  IsSelectAllRows: "IsSelectAllRows",
  selectedDoctorForFilter: "selectedDoctorForFilter",
  SelectedCaseType: "SelectedCaseType",
  MainDates: "MainDates",
  SortBy: "SortBy",
  isCaseUpdate: 'isCaseUpdate',
  searchedCaseNo: 'searchedCaseNo'
};

export const VisitReportSearch = {
  VisitFromDate: "VisitFromDate",
  VisitToDate: "VisitToDate",
  VisitMainDates: "VisitMainDates",
  VisitDateRange: "VisitDateRange",
  VisitSearchResultList: "VisitSearchResultList",
  VisittotalNoRowsReturn: "VisittotalNoRowsReturn",
  VisitSearchParameter: "VisitSearchParameter",
  VisitCaseTypeValue: "VisitCaseTypeValue",
  VisitStatus: "VisitStatus",
  VisitDoctor: "VisitDoctor",
  VisitSpeciality: "VisitSpeciality",
  VisitBillingStatus: "VisitBillingStatus",
  ShowAllCases: "ShowAllCases",
  ShowUnbillableVisit: "ShowUnbillableVisit",
  VisitReferringOffice: "VisitReferringOffice"
}

export const UnSentNF2ReportSearch = {

  UnSentNF2FromDate: "UnSentNF2FromDate",
  UnSentNF2ToDate: "UnSentNF2ToDate",
  UnSentNF2MainDates: "UnSentNF2MainDates",
  UnSentNF2DateRange: "UnSentNF2DateRange",
  UnSentNF2CaseType: "UnSentNF2CaseType",
  UnSentNF2Status: "UnSentNF2Status",
  UnSentNF2Date: "UnSentNF2Date",
}

export const MessageReportSearch = {
  MessageFromDate: "MessageFromDate",
  MessageToDate: "MessageToDate",
  MessageCommMode: "MessageCommMode",
}

export const DailyScheduleReport = {
  DailyScheduleFromDate: "DailyScheduleFromDate",
  DailyScheduleToDate: "DailyScheduleToDate",
  DailyScheduleLocation: "DailyScheduleLocation",
  DailyScheduleDoctor: "DailyScheduleDoctor",
  DailyScheduleSpeciality: "DailyScheduleSpeciality",
  DailyScheduleOrderBy: "DailyScheduleOrderBy",

}

export const PatientAbsenteeReport = {
  PatientAbsenteeFromDate: "PatientAbsenteeFromDate",
  PatientAbsenteeToDate: "PatientAbsenteeToDate",
  PatientAbsenteeSpeciality: "PatientAbsenteeSpeciality",
  PatientAbsenteeReportLocation: "PatientAbsenteeReportLocation",
}


export const TransportReportSearch = {
  TransportFromDate: "TransportFromDate",
  TransportToDate: "TransportToDate",
  TransportName: "TransportName",
  TransportCaseNo: "TransportCaseNo",
  TransportDate: "TransportDate",
}


export const IntakeSheetSession = {
  collectionOfhippaAuth: "collectionOfhippaAuth",
  BeforeParsinghippaAuthData: "BeforeParsinghippaAuthData",
  collectionOfAOB: "collectionOfAOB",
  BeforeParsingAOB: "BeforeParsingAOB",
  collectionOfhippaDeclare: "collectionOfhippaDeclare",
  CollectionOfPregnancyConsent: "CollectionOfPregnancyConsent",
  BeforeParsingPregnancyConsent: "BeforeParsingPregnancyConsent",
  CaseFormDataIdPregnancyConsent: "CaseFormDataIdPregnancyConsent",
  BeforeParsinghippaAuthDeclare: "BeforeParsinghippaAuthDeclare",
  collectionOfNF2: "collectionOfNF2",
  BeforeParsingNF2: "BeforeParsingNF2",
  CaseFormDataIdNF2: "CaseFormDataIdNF2",
  CaseFormDataIdAOB: "CaseFormDataIdAOB",
  CaseFormDataIdHippaAuth: "CaseFormDataIdHippaAuth",
  CaseFormDataIdHippaDeclare: "CaseFormDataIdHippaDeclare",
  collectionOfEPAT: "collectionOfEPAT",
  BeforeParsingEPAT: "BeforeParsingEPAT",
  CaseFormDataIdEPAT: "CaseFormDataIdEPAT",
  collectionOfTriggerConsent: "collectionOfTriggerConsent",
  BeforeParsingTriggerConsent: "BeforeParsingTriggerConsent",
  CaseFormDataIdTriggerConsent: "CaseFormDataIdTriggerConsent",
  collectionOfMedicalLien: "collectionOfMedicalLien",
  BeforeParsingMedicalLien: "BeforeParsingMedicalLien",
  caseFormDataIDMedicalLien: "caseFormDataIDMedicalLien",
  CollectionOfPatientConsent: "CollectionOfPatientConsent",
  BeforeParsingPatientConsent: "BeforeParsingPatientConsent",
  CaseFormDataIdPatientConsent: "CaseFormDataIdPatientConsent",
  CollectionOfAOBNJ: "CollectionOfAOBNJ",
  BeforeParsingAOBNJ: "BeforeParsingAOBNJ",
  CaseFormDataIdAOBNJ: "CaseFormDataIdAOBNJ",
  CollectionOfDurablePowerOfAttorney: "CollectionOfDurablePowerOfAttorney",
  BeforeParsingDurablePowerOfAttorney: "BeforeParsingDurablePowerOfAttorney",
  CaseFormDataIdDurablePowerOfAttorney: "CaseFormDataIdDurablePowerOfAttorney",
  CollectionOfPatientDoctorContract: "CollectionOfPatientDoctorContract",
  BeforeParsingPatientDoctorContract: "BeforeParsingPatientDoctorContract",
  CaseFormDataIDPatientDoctorContract: "CaseFormDataIDPatientDoctorContract",
  collectionOfMedicalVersionV2: "collectionOfMedicalVersionV2",
  BeforeParsingMedicalVersionV2: "BeforeParsingMedicalVersionV2",
  CaseFromDataMedicalVersionV2: "CaseFromDataMedicalVersionV2",

  CaseFormDataIdAcupunctureConsent: "CaseFormDataIdAcupunctureConsent",
  collectionAcupunctureConsent: "CollectionAcupunctureConsent",
  BeforeParsingAcupunctureConsent: "BeforeParsingAcupunctureConsent",

  CaseFormDataIdBotulinumConsent: "CaseFormDataIdBotulinumConsent",
  collectionBotulinumConsent: "CollectionBotulinumConsent",
  BeforeParsingBotulinumConsent: "BeforeParsingBotulinumConsent",

  CaseFormDataIdChiropracticTreatmentConsent: "CaseFormDataIdChiropracticTreatmentConsent",
  collectionChiropracticTreatmentConsent: "CollectionChiropracticTreatmentConsent",
  BeforeParsingChiropracticTreatmentConsent: "BeforeParsingChiropracticTreatmentConsent",

  CaseFormDataIdChiropracticCareConsent: "CaseFormDataIdChiropracticCareConsent",
  collectionChiropracticCareConsent: "CollectionChiropracticCareConsent",
  BeforeParsingChiropracticCareConsent: "BeforeParsingChiropracticCareConsent",

  CaseFormDataIdIVConsent: "CaseFormDataIdIVConsent",
  collectionIVConsent: "CollectionIVConsent",
  BeforeParsingIVConsent: "BeforeParsingIVConsent",

  CaseFormDataIdDermalFillerConsent: "CaseFormDataIdDermalFillerConsent",
  collectionDermalFillerConsent: "CollectionDermalFillerConsent",
  BeforeParsingDermalFillerConsent: "BeforeParsingDermalFillerConsent",

  CaseFormDataIdPRPInformedConsent: "CaseFormDataIdPRPInformedConsent",
  collectionPRPInformedConsent: "CollectionPRPInformedConsent",
  BeforeParsingPRPInformedConsent: "BeforeParsingPRPInformedConsent",

  CaseFormDataIdConditionalAOB: "CaseFormDataIdConditionalAOB",
  collectionConditionalAOB: "CollectionConditionalAOB",
  BeforeParsingConditionalAOB: "BeforeParsingConditionalAOB",

  dataBlock: "data:image/png;base64,",
  dataBlock1: "data:image/jpeg;base64,",

  intakecollection: "intakecollection",
  intakeFormData: "intakeFormData",
  intakeCaseFormId: "intakeCaseFormId",

  CollectionOfSpineTime: "CollectionOfSpineTime",
  BeforeParsingSpineTime: "BeforeParsingSpineTime",
  CaseFormDataIdSpineTime: "CaseFormDataIdSpineTime",

  CollectionOfLaserConsent: "CollectionOfLaserConsent",
  BeforeParsingLaserConsent: "BeforeParsingLaserConsent",
  CaseFormDataIdLaserConsent: "CaseFormDataIdLaserConsent",

  CollectionOfBrainQuestionnaire: "CollectionOfBrainQuestionnaire",

  CollectionOfWaiverReleaseForm: "CollectionOfWaiverReleaseForm",
  BeforeParsingWaiverReleaseForm: "BeforeParsingWaiverReleaseForm",
  CaseFormDataIdWaiverReleaseForm: "CaseFormDataIdWaiverReleaseForm",
};

export const MedicalLienVersion2Constant = {
  txtFormSubmissionDate: "txtFormSubmissionDate",
  txtProviderAddress: "txtProviderAddress",
  txtProviderPhone: "txtProviderPhone",
  txtProviderFax: "txtProviderFax",
  txtDOL: "txtDOL",
  txtPatientName: "txtPatientName",
  txtPatientSignDate: "txtPatientSignDate",
  signPatientSign: "signPatientSign",
  txtSpecialityServ: "txtSpecialityServ",
  txtPhysicianName: "txtPhysicianName",
  ddlPhysicianList: "ddlPhysicianList",
  txtAttorneyName: "txtAttorneyName",
  txtAttorneySignDate: "txtAttorneySignDate",
  signAttorneySign: "signAttorneySign",
};

export const PatientConsent = {
  txtConsentGiverName: "txtConsentGiverName",
  sigConsentGiverSign: "sigConsentGiverSign",
  txtConsentGiverSignDate: "txtConsentGiverSignDate",
  txtRelationWithPatient: "txtRelationWithPatient",
  txtWitnessName: "txtWitnessName",
  txtPhysicianName: "txtPhysicianName",
  ddlPhysicianList: "ddlPhysicianList",
};

export const DurablePowerOfAttorneyConstant = {
  txtPatientAddress: "txtPatientAddress",
  txtPatientName: "txtPatientName",
  signPatientSign: "signPatientSign",
  txtPatientSignDate: "txtPatientSignDate",
  txtCountryName: "txtCountryName",
  txtNotaryDate: "txtNotaryDate",
  txtNotaryYear: "txtNotaryYear",
  signNotaryOfficerSign: "signNotaryOfficerSign",
  txtCommissionExpireDate: "txtCommissionExpireDate",
  txtNotaryMonth: "txtNotaryMonth",
  txtProviderAddress: "txtProviderAddress",
  txtPhysicianName: "txtPhysicianName",
  txtPatientSignDay: "txtPatientSignDay",
  txtPatientSignMonth: "txtPatientSignMonth",
  txtPatientSignYear: "txtPatientSignYear",
  txtNotaryDay: "txtNotaryDay",
  ddlPhysicianList: "ddlPhysicianList",
  txtPhyNameProviderAddress: "txtPhyNameProviderAddress",
};

export const PatientDoctorContractConstant = {
  sigPatientSign: "sigPatientSign",
  txtPatientFullName: "txtPatientFullName",
  sigPhysicianSign: "sigPhysicianSign",
  ddlPhysicianList: "ddlPhysicianList",
  txtPhysicianName: "txtPhysicianName",
  txtContractDate: "txtContractDate",
  txtPatientSignDate: "txtPatientSignDate",
};

export const AOBNJConstant = {
  txtPatientName: "txtPatientName",
  txtClaimNumber: "txtClaimNumber",
  signPatientSign: "signPatientSign",
  txtPatientSignDate: "txtPatientSignDate",
  txtDOL: "txtDOL",
  txtDoctorName: "txtDoctorName",
  txtProviderAddress: "txtProviderAddress",
  ddlPhysicianList: "ddlPhysicianList",
  txtPhysicianName: "txtPhysicianName",
};

export const TriggerPointConsent = {
  ProviderName: "ProviderName",
  ProviderAddress: "ProviderAddress",
  PatientName: "PatientName",
  PatientSign: "PatientSign",
  PatientSignDate: "PatientSignDate",
  PhysicianSign: "PhysicianSign",
  PhysicianSignDate: "PhysicianSignDate",
  FormSubDate: "FormSubDate",
  Procedures: "Procedures",
};

export const BrainQuestionnaireConstant = {
  PatientSign: "PatientSign",
  txtDate: "txtDate",
  signPCPatientSign: "signPCPatientSign",
};

export const NF2Constant = {
  InsurerName: "InsurerName",
  InsurerAddress: "InsurerAddress",
  PolicyHolder: "PolicyHolder",
  PolicyNumber: "PolicyNumber",
  ClaimNumber: "ClaimNumber",
  RepresentativeInfo: "RepresentativeInfo",
  AIName: "AIName",
  AIPhoneNo: "AIPhoneNo",
  AIHomePhNo: "AIHomePhNo",
  AIBussPhNo: "AIBussPhNo",
  AISSN: "AISSN",
  AIDOB: "AIDOB",
  AIDOA: "AIDOA",
  AITOA: "AITOA",
  AIAddress: "AIAddress",
  AIAccPlaceInfo: "AIAccPlaceInfo",
  AIAccDesc: "AIAccDesc",
  AIInjuryDesc: "AIInjuryDesc",
  AISignDate: "AISignDate",
  AISign: "AISign",
  VIOwnerName: "VIOwnerName",
  VIMake: "VIMake",
  VIYear: "VIYear",
  VITypeBus: "VITypeBus",
  VITypeTruck: "VITypeTruck",
  VITypeAutomobile: "VITypeAutomobile",
  VITypeMotorcycle: "VITypeMotorcycle",
  VIDriverYes: "VIDriverYes",
  VIDriverNo: "VIDriverNo",
  VIPassengerYes: "VIPassengerYes",
  VIPassengerNo: "VIPassengerNo",
  VIPedestrianYes: "VIPedestrianYes",
  VIPedestrianNo: "VIPedestrianNo",
  VIPolicyMbrYes: "VIPolicyMbrYes",
  VIPolicyMbrNo: "VIPolicyMbrNo",
  VIRelativeYes: "VIRelativeYes",
  VIRelativeNo: "VIRelativeNo",
  TIByDoctorYes: "TIByDoctorYes",
  TIByDoctorNo: "TIByDoctorNo",
  TIDoctorInfo: "TIDoctorInfo",
  TIOutPatientYes: "TIOutPatientYes",
  TIInPatientYes: "TIInPatientYes",
  TIHospitalInfo: "TIHospitalInfo",
  TIAddmitDate: "TIAddmitDate",
  TIBillAmtToDate: "TIBillAmtToDate",
  TIMoreTreatmentYes: "TIMoreTreatmentYes",
  TIMoreTreatmentNo: "TIMoreTreatmentNo",
  TICourseEmpYes: "TICourseEmpYes",
  TICourseEmpNo: "TICourseEmpNo",
  WILoseTime: "WILoseTime",
  WIAbsenceDate: "WIAbsenceDate",
  WIReturnWork: "WIReturnWork",
  WIReturnDate: "WIReturnDate",
  WITimeLost: "WITimeLost",
  WIWeeklyEarning: "WIWeeklyEarning",
  WINoDayWeek: "WINoDayWeek",
  WINoHrsDay: "WINoHrsDay",
  WIUnempBenefitYes: "WIUnempBenefitYes",
  WIUnempBenefitNo: "WIUnempBenefitNo",
  EI1Address: "EI1Address",
  EI1Occupation: "EI1Occupation",
  EI1FromDate: "EI1FromDate",
  EI1ToDate: "EI1ToDate",
  EI2Address: "EI2Address",
  EI2Occupation: "EI2Occupation",
  EI2FromDate: "EI2FromDate",
  EI2ToDate: "EI2ToDate",
  EI3Address: "EI3Address",
  EI3Occupation: "EI3Occupation",
  EI3FromDate: "EI3FromDate",
  EI3ToDate: "EI3ToDate",
  OIOtherExpYes: "OIOtherExpYes",
  OIOtherExpNo: "OIOtherExpNo",
  OINYStDisabYes: "OINYStDisabYes",
  OINYStDisabNo: "OINYStDisabNo",
  OIWCYes: "OIWCYes",
  OIWCNo: "OIWCNo",
  OIFormDate: "OIFormDate",
};

export const AOBConstant = {
  PatientName: "PatientName",
  ProviderName: "ProviderName",
  AccidentDate: "AccidentDate",
  PatientName2: "PatientName2",
  PatientSign: "PatientSign",
  PatientSignDate: "PatientSignDate",
  PatientAddress: "PatientAddress",
  ProviderName2: "ProviderName2",
  ProviderSign: "ProviderSign",
  ProviderSignDate: "ProviderSignDate",
  ProviderAddress: "ProviderAddress",
  PatientDOA: "AccidentDate",
};

export const ConditionalAOBConsant = {
  PolicyNumber: "txtPolicyNumber",
  ClaimNumber: "txtClaimNumber",
  PatientName: "txtPatientName",
  PatientSign: "signPatientSign",
  PatientSignDate: "txtPatientSignDate",
  LegalPersonName: "txtGaurdianName",
  ProviderName: "txtProviderName",
  ProviderSign: "ProviderSign",
  ProviderSignDate: "txtProviderSignDate",
  ProviderAddress: "txtProviderAddress",
  ProviderContact: "txtProviderContact",
  TpinNumber: "txtTIN",
};

export const HippaDeclareConstant = {
  PatientName: "PatientName",
  AccidentDate: "AccidentDate",
  ProviderName: "ProviderName",
  ProviderNameAddress: "ProviderNameAddress",
  PatientName2: "PatientName2",
  PatientSign: "PatientSign",
  PatientSignDate: "PatientSignDate",
  PatientSSN: "PatientSSN",
  GuardianName: "GuardianName",
  GuardianSign: "GuardianSign",
  GuardianSignDate: "GuardianSignDate",
};

export const IntakeFormConst = {
  // PIPatientName: "PIPatientName",
  // PISSN: "PISSN",
  // PIAge: "PIAge",
  // PIHomePhone: "PIHomePhone",
  // PIWorkPhone: "PIWorkPhone",
  // PIMailingAdd: "PIMailingAdd",
  // PICity: "PICity",
  // PIState: "PIState",
  // PIZip: "PIZip",
  // PIAccidentDate: "PIAccidentDate",
  // PIBirthDate: "PIBirthDate",
  PIMale: "PIMale",
  PIFemale: "PIFemale",
  PISingle: "PISingle",
  PIMarried: "PIMarried",
  PIOther: "PIOther",
  PIPregnantYes: "PIPregnantYes",
  PIPregnantNo: "PIPregnantNo",
  // IIInsuranceCompName: "IIInsuranceCompName",
  IIInsuredName: "IIInsuredName",
  IIAdjusterPhone: "IIAdjusterPhone",
  IIInsuranceCompAdd: "IIInsuranceCompAdd",
  IIWorkComp: "IIWorkComp",
  IINofault: "IINofault",
  IIOtherCaseType: "IIOtherCaseType",
  IIDriver: "IIDriver",
  IIPassenger: "IIPassenger",
  IIPedestrian: "IIPedestrian",
  IIOtherPatientType: "IIOtherPatientType",
  WCEmpName: "WCEmpName",
  WCEmpPhone: "WCEmpPhone",
  WCClaimNo: "WCClaimNo",
  WCPolicyNo: "WCPolicyNo",
  WCWCBNo: "WCWCBNo",
  WCInjuryCaseEst: "WCInjuryCaseEst",
  WCAttorneyName: "WCAttorneyName",
  WCAttorneyPhone: "WCAttorneyPhone",
  WCReferral: "WCReferral",
  WCReferredBy: "WCReferredBy",
  WCAdvertise: "WCAdvertise",
  WCAdvertiseName: "WCAdvertiseName",
  MMIInsCompName: "MMIInsCompName",
  MMIInsCompAdd: "MMIInsCompAdd",
  MMIMemberID: "MMIMemberID",
  MMIGroupNo: "MMIGroupNo",
  MMIInsuranceType: "MMIInsuranceType",
  MMIInsuredDOB: "MMIInsuredDOB",
  MMISelf: "MMISelf",
  MMISpouse: "MMISpouse",
  MMIChild: "MMIChild",
  MMIOther: "MMIOther",
  MMIIndividual: "MMIIndividual",
  MMIEmployee: "MMIEmployee",
  MMIOrganization: "MMIOrganization",
  PatientSign: "PatientSign",
  ProviderSign: "ProviderSign",
  WitnessSign: "WitnessSign",
  PatientSignDate: "PatientSignDate",
  ProviderSignDate: "ProviderSignDate",
  WitnessSignDate: "WitnessSignDate",
  FormDate: "FormDate",
  ProviderName: "ProviderName",
  InitialDirectPay: "InitialDirectPay",

}

export const PregnancyConsents = {
  txtDate: "txtDate",
  txtPatientName: "txtPatientName",
  signPCPatientSign: "signPCPatientSign",
  txtInsuranceName: "txtInsuranceName",
  txtInsuranceAdd: "txtInsuranceAdd",
  txtInsurancePhone: "txtInsurancePhone",
  txtInsuranceFax: "txtInsuranceFax",
  txtInsuranceContact: "txtInsuranceContact",
  txtInsuranceAddress: "txtInsuranceAddress",
  txtInsuranceCity: "txtInsuranceCity",
  txtInsuranceState: "txtInsuranceState",
  txtInsuranceZip: 'txtInsuranceZip',
  txtProviderName: 'txtProviderName',
  txtProviderAddress: 'txtProviderAddress',
  txtProviderAddress2: 'txtProviderAddress2',
  txtProviderContact: 'txtProviderContact',
};

export const HippaAuthConstant = {
  PatientName: "PatientName",
  PatientSign: "PatientSign",
  PatientBirthDate: "PatientBirthDate",
  PatientAddress: "PatientAddress",
  PatientSSN: "PatientSSN",
  HealthProviderInfo: "HealthProviderInfo",
  ReceiverInfo: "ReceiverInfo",
  MedRecord9A: "MedRecord9A",
  MedRecordFromDt9A: "MedRecordFromDt9A",
  MedRecordToDt9A: "MedRecordToDt9A",
  AllMedRecord9A: "AllMedRecord9A",
  OtherRecord9A: "OtherRecord9A",
  OtherTxtRecord9A: "OtherTxtRecord9A",
  MedIncAlcDrug9A: "MedIncAlcDrug9A",
  MedIncMentalHealth9A: "MedIncMentalHealth9A",
  MedIncHIVInfo9A: "MedIncHIVInfo9A",
  ByInitiate9B: "ByInitiate9B",
  InitiateHere9B: "InitiateHere9B",
  IAuthorize9B: "IAuthorize9B",
  FirmGovAgency9B: "FirmGovAgency9B",
  ReleaseReasonText10: "ReleaseReasonText10",
  ReasonAtRequest10: "ReasonAtRequest10",
  ReasonOther10: "ReasonOther10",
  AuthExpireDate11: "AuthExpireDate11",
  OtherPersonName12: "OtherPersonName12",
  OtherAuthority13: "OtherAuthority13",
  ProviderName: "ProviderName",
  FormDate: "FormDate",
};

export const Environement = {
  SelectEnvironement: "SelectEnvironement",
  PROD: "PROD",
  UAT: "UAT",
  STAGING: "STAGING",
  DEV: "DEV",
  abgreenyourbillscom: "ab.greenyourbills.com",
  AbGybDev: "AbGybDev",
  SetCurrentConfigSession: "SetCurrentConfigSession",
  SetCurruntEnvironement: "SetCurruntEnvironement",
};

export const EnvironementName = {
  PROD: "PROD",
  UAT: "UAT",
  STAGING: "STAGING",
  DEV: "DEV",
  AB: "AB",
  ABDev: 'AB'


};

export const EnvironementVariable = {
  API: "API",
  IDENTITY: "IDENTITY",
  CLIENT_ID: "CLIENT_ID",
};

export const EPATConstant = {
  PatientSign: "PatientSign",
  PatientName: "PatientName",
  PatientSignDate: "PatientSignDate",
  ProviderName: "ProviderName",
  ProviderAddress: "ProviderAddress",
};

export const MedicalLienConstant = {
  PatientName1: "PatientName1",
  PatientAddress: "PatientAddress",
  BeginingDate: "BeginingDate",
  PhysicianName1: "PhysicianName1",
  PhysicianName2: "PhysicianName2",
  PhysicianName3: "PhysicianName3",
  PhysicianName4: "PhysicianName4",
  PhysicianName5: "PhysicianName5",
  AboutText: "AboutText",
  Amount: "Amount",
  HereOntuDate: "HereOntuDate",
  PatientName2: "PatientName2",
  signPatientSign: "signPatientSign",
  PatientSignDate: "PatientSignDate",
  AttorneyName: "AttorneyName",
  signAttorneySign: "signAttorneySign",
  AttorneyAddress: "AttorneyAddress",
  PatientSign: "PatientSign",
  AttorneySign: "AttorneySign",
};

export const AcupunctureConsentConstant = {
  PatientName: "PatientName",
  PatientRelation: "PatientRelation",
  PatientSign: "PatientSign",
  PatientSignDate: "PatientSignDate",
  ProviderSignDate: "ProviderSignDate",
  ProviderSign: "ProviderSign",
  GuardianName: "GuardianName",
  ProviderInfo: "ProviderInfo",
  ProviderName: "ProviderName"
};

export const BotulinumConsentConstant = {
  PatientName: "PatientName",
  ProviderName: "ProviderName",
  ProviderAddress: "ProviderAddress",
  ClientSign: "ClientSign",
  ClientSignDate: "ClientSignDate",
  WitnessSign: "WitnessSign",
  WitnessSignDate: "WitnessSignDate",
};

export const ChiropracticTreatmentConsentConstant = {
  FormDate: "FormDate",
  PatientName: "PatientName",
  PatientSign: "PatientSign",
  PhysicianSign: "PhysicianSign",
  GuardianName: "GuardianName",
  PatientRelation: "PatientRelation",
  PatientSignDate: "PatientSignDate",
  PhysicianSignDate: 'PhysicianSignDate'
};

export const ChiropracticCareConsentConstant = {
  FormDate: "FormDate",
  PatientName: "PatientName",
  PatientSign: "PatientSign",
  PatientAge: "PatientAge",
  OtherText: "OtherText",
  DoctorName: "DoctorName",
  DoctorSign: "DoctorSign",
  LegalPersonName: "LegalPersonName",
  LegalPersonRelation: "LegalPersonRelation",
  LegalPersonSign: "LegalPersonSign",
  ProviderName: "ProviderName",
  ProviderAddress: "ProviderAddress",
};

export const IVConsentConstant = {
  PatientName: "PatientName",
  PatientSign: "PatientSign",
  PatientSignDate: "PatientSignDate",
  ProviderName: "ProviderName",
  ProviderAddress: "ProviderAddress",
  WitnessName: "WitnessName",
  WitnessSign: "WitnessSign",
  WitnessSignDate: "WitnessSignDate",
  LogoImage: "LogoImage",
};

export const DermalFillerConsentConstant = {
  PatientName: "PatientName",
  PatientEmail: "PatientEmail",
  PatientTelephone: "PatientTelephone",
  PatientAddress: "PatientAddress",
  PatientAge: "PatientAge",
  PatientHeight: "PatientHeight",
  PatientWeight: "PatientWeight",
  PatientSign1: "PatientSign1",
  PatientSign2: "PatientSign2",
  PatientSignDate: "PatientSignDate",
  ProviderName: "ProviderName",
  ProviderAddress: "ProviderAddress",
  PhysicianName: "PhysicianName",
  MedicationsText: "MedicationsText",
  AllergiesText: "AllergiesText",
  PregnantLactatingText: "PregnantLactatingText",
  AnaphylaxisHistoryCheck: "AnaphylaxisHistoryCheck",
  MultipleSevereAllergiesCheck: "MultipleSevereAllergiesCheck",
  FacialAcneCheck: "FacialAcneCheck",
  HivesCheck: "HivesCheck",
  ImmunosuppressiveTherapyaCheck: "ImmunosuppressiveTherapyaCheck",
  AutoimmuneDieseaseCheck: "AutoimmuneDieseaseCheck",
  HerpesCheck: "HerpesCheck",
  FacialRashesCheck: "FacialRashesCheck",
  ActiveImflammatoryProcessCheck: "ActiveImflammatoryProcessCheck",
  OtherMedicalDiseaseCheck: "OtherMedicalDiseaseCheck",
  OtherMedicalDiseaseText: "OtherMedicalDiseaseText",
  WitnessName: "WitnessName",
  WitnessSign: "WitnessSign",
  WitnessSignDate: "WitnessSignDate",
  LogoImage: "LogoImage"
};

export const PRPInformedConsentConstant = {
  PatientName: "PatientName",
  PatientSign: "PatientSign",
  PatientSignDate: "PatientSignDate",
  DoctorName: "DoctorName",
  DoctorSign: "DoctorSign",
  DoctorSignDate: "DoctorSignDate",
  LogoImage: "LogoImage",
};

export const IntakeSheetType = {
  HIPPAAuthorization: "HIPPA Authorization",
  HIPPADeclaration: "HIPPA Declaration",
  NF2: "NF 2",
  AssignmentOfBenifits: "Assignment of Benefits",
  EPAT: "EPAT Consent",
  TriggerPointInjectionConsent: "Trigger Point Injection Consent",
  TriggerPointInjectionConsentV1: "Trigger Point Injection Consentv1",
  MedicalLIEN: "Medical LIEN",
  NJPOwerOfAttorney: "NJ Durable Power of Attorney",
  NJAOB: "NJ Assignment of Benifits",
  DoctorPatientPainContract: "Doctor Patient Pain Contract",
  PatientConsent: "Patient Consent",
  MedicalLienVersion2: "Attorney Notice of Irrevocable Practice Lien",
  AcupunctureConsent: "Acupuncture Informed Consent To Treat",
  ChiropracticTreatmentConsent: "Informed Consent to Chiropractic Treatment",
  ChiropracticCareConsent: "Informed Consent To Chiropractic Care",
  BotulinumConsent: "Botulinum Toxin Treatment Consent Form",
  IVConsent: "IV Consent Form",
  DermalFillerConsent: "Dermal Filler Consent Form",
  PRPInformedConsent: "Platelet Rich Plasma Informed Consent",
  ConditionalAOB: "Geico AOB",
  PregnancyConsent: "Pregnancy Consent",
  IntakeForm: "Intake Form",
  MinorConsentForm: "MINOR CONSENT FORM",
  WCPatientInfo: "Workers Compensation Patient Information",
  NFPatientInfo: "No fault Patient Information",
  XrayConsentF: "X-Ray Consent",
  Assist: 'Assist',
  SpineQuestionnarie: 'SPINE QUESTOINNAIRE',
  AOB: "AOB",
  ProviderAOB: "ProviderAOB",
  PatientDisclosureForm: 'PatientDisclosureForm',
  BrainQuestionnaire: "BRAIN QUESTOINNAIRE",
  TriggerPointInjectionConsentV1: "Trigger Point Injection Consentv1",
  SpineTimeChiropractic: "Spine Time Chiropractic",
  PatientAcknowledgmentAndConsent: "PATIENT ACKNOWLEDGMENT AND CONSENT",
  IntakeFormWithBodyPart: "Intake Form With Body Part",
  LaserConsentForm: "Laser Consent Form",
  WaiverReleaseForm: "Waiver Release Form",
};

export const AppointmentSearchValue = {
  Today: "Today",
  All: "All",
  ALL: "ALL",
  ThisWeek: "This Week",
  ThisMonth: "This Month",
  ThisQuarter: "This Quarter",
  ThisYear: "This Year",
  LastWeek: "Last Week",
  LastMonth: "Last Month",
  LastQuarter: "Last Quarter",
  LastYear: "Last Year",

  Last3Months: "Last 3 Months",
  Custom: "Custom",
};
export const WaiverReleaseForms = {
  txtDate: "txtDate",
  txtPatientName: "txtPatientName",
  signPCPatientSign: "signPCPatientSign",
  txtProviderName: 'txtProviderName',
};

export const SpineQuestionnaireConstant = {
  PatientSign: "PatientSign",
  txtDate: "txtDate",
  signPCPatientSign: "signPCPatientSign",
};

export const PrescriptionType = {
  NewPrescription: "New Prescription",
  PrescriptionHistory: "Prescription History",
};

export const IMESWT2_1Text = {
  FirstDescription:
    "The patient was brought into the room having weighed the risks and alternatives. The patient had been healthy lately, with no evicence of infectious disease and physucal exam unchanged from prior visit. After informed consent was was reviewed, signed and accepted the patient was positioned in the optimal position for treatment and their localized area of discomfort/pain was marked to be addressed. Previous examination findings and diagnostic imaging indicating lesions, scarring and/or inflammation were reviewed.",

  SecondDescription:
    "I had the opportunity to first visually inspect and palpate/scan the tendons and muscles with both hands, feeling for dense/taught/tender fibers, scars, adhesions, contractures as well as including any and all soft tissue thickenings. As well as I felt for any swollen areas, inflammation and/or twitch responses. The areas planned on application were assessed for both active and passive range of motion.",

  ThirdDescription:
    "After preparation of the targeted body part, a liberal amount of conductive gel was placed along the entire encompassing region. Treatment began at the point of maximum pain as indicated by the patient & elicited by myself as the provider. The primary point of pain was treated in order to achieve the maximal point of elimination caused by the analgesic effect of shock waves (approximately 400 radial pulses). Based upon dialogue between myself and the patient, further painful spots were localized and treated.",

  FourthDescription: "The patient was observed briefly after treatment was completed without any complications and was given a follow up  appointment. The patient is to call the office if any concerns anse.",

  UltraText: "Ultra Sound imaging was used to insure targeted pulsing to affected area.",
};

export const TabValueForIMandPMInitial = {
  tabPatientDetailsIllnessHistory: "tabPatientDetailsIllnessHistory",
  tabCurrentComplaint: "tabCurrentComplaint",
  tabMedicalHistory: "tabMedicalHistory",
  tabPhysicalExamination: "tabPhysicalExamination",
  tabSpinalRangeofMotion: "tabSpinalRangeofMotion",
  tabNeurologicalExamination: "tabNeurologicalExamination",
  tabOrtopedic: "tabOrtopedic",
  tabMangementPlan: "tabMangementPlan",
  tabDisabilityProgonosis: "tabDisabilityProgonosis",
  tabTechniques: "tabTechniques",
  tabWorkAndStatus: "tabWorkAndStatus",
  tabReviewOfSystem: "tabReviewOfSystem",
  tabPhysicalTherapyPrescription: "tabPhysicalTherapyPrescription",
  tabBotoxInjection: "tabBotoxInjection",
  tabDermalFiller: "tabDermalFiller",
  tabIntravenous: "tabIntravenous",
  tabPlateletPlasma: "tabPlateletPlasma",
  tabPhysicalTherapyReferral: "tabPhysicalTherapyReferral",
  tabDiagnosticImpression: "tabDiagnosticImpression",
  tabProcedure: "tabProcedure",
  tabSubjective: "tabSubjective",
  tabObjective: "tabObjective",
  tabMedicalEvaluationTestResult: "tabMedicalEvaluationTestResult",
  tabOfficeProcedures: "tabOfficeProcedures",
  tabMedicalJustification: 'tabMedicalJustification',
  tabOrderReferralForm: "tabOrderReferralForm",
  tabPalpation: "tabPalpation",
  tabChiefComplaints: "tabChiefComplaints",
  tabFunctionalLimitations: "tabFunctionalLimitations",
  tabObjectiveInspection: "tabObjectiveInspection",
  tabRomMuscleStrength: "tabRomMuscleStrength",
};

export const TabValueForProcedure = {
  tabTriggerPoints: "tabTriggerPoints",
  tabUltraSound: "tabUltraSound",
  tabNerveBlocks: "tabNerveBlocks",
};
export const TabValueForTmFlowReport = {
  tabPhysician: "tabPhysician",
  tabInterpretor: "tabInterpretor"
}

export const sign = {
  SignatureOnFile:
    "data:image/jpeg;base64,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",
};

export const XtheticMDLogoBase64 = {
  xtheticMDLogoBase64:
    "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/4RE0RXhpZgAATU0AKgAAAAgABQESAAMAAAABAAEAAAITAAMAAAABAAEAAIdpAAQAAAABAAAIVpycAAEAAAAWAAARFuocAAcAAAgMAAAASgAAAAAc6gAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALkAAABwAAAAQwMjIxkAMAAgAAABQAABDskAQAAgAAABQAABEAkQEABwAAAAQBAgMAkpEAAgAAAAMwMAAAkpIAAgAAAAMwMAAAoAAABwAAAAQwMTAwoAIABAAAAAEAAARloAMABAAAAAEAAAmEpAYAAwAAAAEAAAAA6hwABwAACAwAAAjgAAAAABzqAAAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMjAyMjowMTowNyAxNjoxMDowMgAyMDIyOjAxOjA3IDE2OjEwOjAyAAAAUwBjAHIAZQBlAG4AcwBoAG8AdAAAAP/iAjRJQ0NfUFJPRklMRQABAQAAAiRhcHBsBAAAAG1udHJSR0IgWFlaIAfhAAcABwANABYAIGFjc3BBUFBMAAAAAEFQUEwAAAAAAAAAAAAAAAAAAAAAAAD21gABAAAAANMtYXBwbMoalYIlfxBNOJkT1dHqFYIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACmRlc2MAAAD8AAAAZWNwcnQAAAFkAAAAI3d0cHQAAAGIAAAAFHJYWVoAAAGcAAAAFGdYWVoAAAGwAAAAFGJYWVoAAAHEAAAAFHJUUkMAAAHYAAAAIGNoYWQAAAH4AAAALGJUUkMAAAHYAAAAIGdUUkMAAAHYAAAAIGRlc2MAAAAAAAAAC0Rpc3BsYXkgUDMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAdGV4dAAAAABDb3B5cmlnaHQgQXBwbGUgSW5jLiwgMjAxNwAAWFlaIAAAAAAAAPNRAAEAAAABFsxYWVogAAAAAAAAg98AAD2/////u1hZWiAAAAAAAABKvwAAsTcAAAq5WFlaIAAAAAAAACg4AAARCwAAyLlwYXJhAAAAAAADAAAAAmZmAADypwAADVkAABPQAAAKW3NmMzIAAAAAAAEMQgAABd7///MmAAAHkwAA/ZD///ui///9owAAA9wAAMBu/+EJnGh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8APD94cGFja2V0IGJlZ2luPSfvu78nIGlkPSdXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQnPz4NCjx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iPjxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+PHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9InV1aWQ6ZmFmNWJkZDUtYmEzZC0xMWRhLWFkMzEtZDMzZDc1MTgyZjFiIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iPjx4bXA6Q3JlYXRlRGF0ZT4yMDIyLTAxLTA3VDE2OjEwOjAyPC94bXA6Q3JlYXRlRGF0ZT48L3JkZjpEZXNjcmlwdGlvbj48L3JkZjpSREY+PC94OnhtcG1ldGE+DQogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIAogICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgCiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAKICAgICAgICAgICAgICAgICAgICAgICAgICAgIDw/eHBhY2tldCBlbmQ9J3cnPz7/2wBDAAEBAQEBAQEBAQEBAQECAgMCAgICAgQDAwIDBQQFBQUEBAQFBgcGBQUHBgQEBgkGBwgICAgIBQYJCgkICgcICAj/2wBDAQEBAQICAgQCAgQIBQQFCAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAj/wAARCAAyANMDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD+/SUsq7gM45r8dv8AgpH/AMFTNX/4J5eMfh9o+ofs5eIviZ4T8QWMs1vr0etLZWkd0j/Na/6qTMoXa/OMqeM4OP2Nr5S/bN/ZO+HX7ZvwF8V/A/4i26Q2t8vn6bqKRbptH1BVPk3UP+0pPI/iUlTwa8vOqeKlhZRwMuWr0bV16fM/VPBXNeF8HxNhK3GWFeJy3mtVjGUoSUZac0XBqV4/Fa/vWt1P58/+ImvR2Pz/ALIGqt/3OSf/ACLXrnwT/wCDkP4IeM/H2ieFfi38DfFfwg8MX88dufEEOtR6jBp7McCS5jEUbrCOMuu4jqRgZr+UL9o34C/ET9ln4veOPgt8WNLk0vxVodw0bSbWEWoW5yYrqAn70Uq/Mp+oPIIr5yju77UWLQq4tz6cD8TX8zS8UM+o1nTrTXuvVOK6dNj/AKSa37NjwHzbKaeIyfC1HHFQ5qVSniK0vdkrxnFSnKL3T96LXdH+sZpev6drdjaanpFxBqWnXEKXFtPDIrx3ETAFXRhwVIIIPvX4Fftdf8HAfwG+AfxR1/4VfDH4Y698dNX0W4ax1XVIdTistOhuVJDxQSbJGmKMNrMAFyCATiv53fhB/wAFbv2mPhF+w/4y/Y80bVZZ764cWPh3xY10323w3o0gb7TZR8ZZugikyDEruBnCY/LC3gcZzJ5jdTnnmvtc+8VqlajTjlfu1HrJuzt5L/Psfy59GX9kVRo51j63iVF1cHSk4YeMKjj7WO/tpuDUoq1kqd0+bmveKV/6vv8AiJttRgN+yFcfh4uUf+2tfeX7BX/BY+8/bo+NmnfCPQP2ZvE/haz+xzX2payutJc2+kxIuVaRfLUkO21Bgg5boQDX8Tfg34Z+IfHXiTwp4S8O2U+qeItavIrHT7OFMyXM8jBI41HdixA//VX+g1/wTf8A2EPC37EHwN0/wxaw6dc/E7VhHeeKtSjUkz3G0Yt0Y8mKLJUf3jubHNejwDnudY7FS+sVOanHf3UvkfM/tAPADwL8MeGPq+U5e3nGKuqK9vWlyJfFVkpTatHaKa96WmyZ+jKEleRinU1AwGGIJ9qzdS1rS9GjWbV9R0/SrZm2rJczrErN1wCxHPtX7Of4VmpRUFtc295bw3dpPDc20ih45I2DK6noQw4I+lT0AFFFFABRRSMyorMxCqOSTwAKAForD0zxHoWtNMujazo+rmPHmfZbpJjHnpuCk4zj9K3KACikY4BIGTX4weHP+Dg7/gkl4p+OGlfs46T+1bYD4w3vihfBtvpd14b1a3RtXa6+yrbtcyWwhXM3yby4Xkc4oA/aCimIxdFZlKH+76V+VP7Xn/BbX/gmf+wl8Y7r4BftRftIWfw4+K8Gm22rT6Uug6nftBbThjEXktbeRFZgu7YTu2lSRhhkA/VmivmNv2w/2fF/ZPP7cH/Cdxn9mL/hEB48HiUWdxg6H5Hn/avs+zzseX82zZv7YzX5Sx/8HPf/AARHkZF/4bMgTd/e8Ga8Av1/0KgD99qK+Cf2WP8AgqH/AME/f22NR/sP9l39q/4P/FrxP5Xnf2La6l9m1Xy+7f2fciO4IHchDivvagAooooAKCM9RRSE/Si4H4q/8FlP+Ca9p+2x8D38ZfDrToE/aM8KW0s2iyIu1tetB88mmyN/tYZoyfuyccBmr+CLUoZ9EurjSr+yuNOv7eR4JrWaMxyW7qxVkdDyrAggg85Ff6lfxv8AjT4B/Z9+FvjL4xfFHXLTw/4D0Gzkvb+5dvmwv3Y416vK7FUVRyzMAK/zTv2t/jjZftNftGfF749WfgjRvhzY+JdWe+h0mzXAt4woRWlYcNO4UPIwwC7NgV/NfjlgsHTqU8RGVq09491/M/TY/wChT9jX4k8WY7L8w4fxFF1MrwyTp1pbUpyd3Rjf4oyTc7L4Hv8AEj5wfVvLyUhZv0qnJ4nktkMot4UC/MzMxwoHOaWWNpGAijdj/srmut+HFxZ+E/HPg7xjr/hrR/F2k6XqlrqM2jagu621RYpA5gnUdY224I75r8Vy2UnOKjp59j/YziPFZx7Op/Z95zSbSVldpaK70V3of1y/8EFP+CcGr6Ho+k/t2/tE6VcnxvqVuyfDjRL2Equg6bIvzam0R+7cXCtiPPKREnrJx/SP8Tvi18K/gp4XHiv4yfErwF8KfBpuI7NtX8RavBpdms0mdkf2idlQO21sAtk44ryj9j39pn4Y/tX/AAI8IfGL4V3tmdBu4Vt7jT4yA+i3caKslnIo+60Z49Cu0jg1k/trfsNfs4f8FCfgw37P/wC1R4P1Lx38Kjq1prn9n2uq3OnP9rtw4ifzrZ0kwPNfK7sHPNf3BwzluHwuChTwrvG17/zPuf8AGX9InxE4j4o4wxuZcVRlTxinKDpyv+6UW0qaT2UfxfvdT+cn/gkV/wAHGuu/tkftYftYfCP9sTxd+x38AvhF4LtbiTwjr39sf2QdfdNSNuim5vbtop8wDzMRAE/e+7Xm/wDweN+PvDPj3/gl3+y149+G/jHRfFvhDVPi3ZXWnaxouoJc2eoQHSNTxJDPExSRDjgqSOK/A/8A4N8v+CWf7FX7e37e37fvwJ/ab+Gmr+N/hr4Hs7uXwzaWuv31g9iya01qpaa3lR5P3QC/OSO/Wv2r/wCDs34BfDD9lj/gjp+xX+zx8F9EuvDvwp8I/FDT9H0KxmvJbqS1tU0jVCqNNKWeQ/MfmYk+9e8fiZ+3/wCwT+3d+xp+y1/wTW/4Jt+FP2kf2qvgL8FvFt78FvB0kOneKfFlpY30ytpNvtk8iVxJtb++Rg+pr9kvA/j3wV8TPDOj+N/h14u8L+PfBWoQ+fp+saLqEV7ZX0eSN0U8RZHHB5Umv5A/2D/+Db3/AIJqfG//AIJd/B/40/HLwl8Svi3+0D8QvhXpviy88aan4ovEvNDubjTEmhhsIYpFgSC2DRxIsiSbljAbIO0fHv8AwZqfHzxr4R+Bf/BTHwZrutapr3wx8CrpPjDS9JeZmS1uHt9R+1eQpyI/OWwg3AdWUHrmgD+1749/te/svfss2enah+0l+0H8GPgVZ3nNmfFXiS1017wZxuhjmdWkGQclQQK6f4JftFfAb9pPwtJ42/Z/+M3wt+NXhJHEUmoeFdettTghkOcJI0Dtsfg/K2D7V/k+/sgftgfs4/tRftmftI/tqf8ABWn9l39q7/goNrWsSJJoPh/wbDJc6XobSySnyrpVnhZLeCIRRW8CtsADllJANfbf/BMX4tD4H/8ABfP4MeOv+CeP7N37Wn7OP7F3xJ16x8Ja/wCDPGWl3TR2tpeR+XPHLIGkQ28FyVuYXkkZ4wuC2M5AP6K/+Cx//BxT4l/YX/ac/ZZ+D/7IniP9kX46eAvFAki8bahcaqdTk8M3CalHbPE8lldolsyxmRiswJypOMDn+kjwx+0j+zL+0ro/xA8F/BP9o34JfFW+h0eb+1P+EV8U2OrSaTbyq0YnmS3lfYmc4LYBI61/nKf8HJX/AATS/Y8/Yx/bw/Yj8Gfs+fDrVvCPh/4nXFzq3jSObXLy8bU7mbWoo3ZGnkcwDbNIAse1RkYGRX90P7IP/BHn9gj/AIJpRfG/xv8Asf8Awq134eeIfFHhuTSdZkvPEmoaotxbRB5EVVupZAmGYnK4J79KAPz4/wCDfT/gmD+zp/wTy8UftS6x8B/+Civw6/btuPFFpolpqkGg/Y/+KZ+zSXjI032a+uvml+0OBu2f6k4z2/fb44/tP/s6fszaNa+I/wBoj45/CT4IaBcZ+z3XirxDa6Yt0w6rEJ3UyEZ525r+FL/gy81+y8G/8PWPF11amez0vS/DWoTRxr80kcP9syFR+CnH1r5p/wCCLn7Jmgf8HF37e/7ZP7Yf/BSXxP4u+J3hLwq2n3Fn4Ph1ia0t919Pc/ZbFDEwkg0+1hs2QRRMhdmUsxO/eAf6FfwA/a//AGWv2rLTVb/9mn9oX4NfHe0sNn29vCviK11JrENnaZo4XZowxUgFgM4OOlf4x/xd+Ffjnxb+0D+358XfAV7d2uofDXxnqPiq7a2B8+3t38SCzW6RhyvlT3VqSe27PGK/15/2Mv8AglH+wl/wT38f/ET4i/sf/BZPg1rfivTbTSdcgttZvru1uoLeR5IysN1NKI3DSNlkxnPOcV/BR/wQa/Z98LftY/8ABUT/AILIfsy+NUhPhjx38L/iN4ZuZHXP2Uz+JLNY51/24pPLlUjoyCgD+9v/AIJxftt+F/2yf+Cdf7O37Y2q61p1hBqvg1NQ8WXDSDy9N1KyRotTDn+FUnt7g8/w4Pev8lv/AIKHfE3x9+3v8a/2zf8AgpbrH2qH4eax8VLbwzoplVj+6mtrtrC1Unp5NhpcW4erKe9fqX+zB/wUo8efsBf8Eh/+Cuf/AATH8f6vd+Gvj1a+MYvCfhaxlk2S2qalNLp/iCOHowWKLTncY/ivN3eux/4KK/sYT/sX/wDBtr/wTQ07XtLfSviJ8RPizN8TvEcbw7JBJf6Jc/Y45O+Y7KOzGD0ZpOmTQB/YF8Mta+Jdh/wbpfsu6X8Pf2VfBn7YFjqf7P8Ao2n+IPCPiDxlH4asZtMfSUE0k9zJjfCF3b0WSJyv3XB5H4v/APBNH/gn9+zf+1z8X9e+Hvxg/wCCEfwR8LfCeGH7bqnix/itJa6h4bkmuJT9nj0+2vJXvLaNcQwyjY7+TukYl+P6mv8AgkPpGm6//wAEj/8Agn3o2sW0F5pl18GfDdvPDKoZJo302NWVlPBBDEYNcH/wR2+Bmk/Bv4RftAPDpMljrNx8WPFGjNJJGVaSz029ezgHPJ/1UjF/42ZnYKzMKAP5cv8AguN/wbafCH9iv4DeI/8AgoX/AMEy/EfxN+D3iT4dzQ+Idc8Lrrk9x9jsUkAfUdJvmb7TbzW5ZZGRpHBjDspUoFb+iH/g3U/4KVeL/wDgph/wT30Lx98XdQi1X4/eC9Wk8EeMr1VCHWJoYYpbfUGQABXmgmj37cAypKQACBXsv/Be348/D74Af8Ekv23te8f6tptiviDwPqPgvRbeZwH1LVdSha1t4Yl6uw81pSB0SJ26Ka/Ez/gyo+Fnivwt+wh+0z8UtZs57Tw34q+JS2+js/AuksbCKOWVPVfMnaPP96Jh2oA/s1ooooAKr3MkcMZkklSJVy2WbA4Hf2qV22qTX89v/Bcb9v8A8ffATwNYfs4/CLTdVsfGfivT3m1bXFt5ALHS2LRmK3ccedIVYMf4U92FcGaZhHC4eWIlqo/ifqvgn4Q5px5xNheF8osq1eXxSdowitZTl5RWvd7LU/If/gsz+3/cfte/E+T4GfDzXjY/s3eDtSkWS5jk2jxZq8eUe4GTg28J3JGDkFiz91x+Iot/DkUE0dvDZPcxgFZJJCd475yOvsK5O4kvp5JDcRXkj7ju3Ketdz8Kvgb8Vvj1430P4cfCTwD4l8ceMdQmWG3tbO1d1TJx5k0gG2KJerOxCgDrX8f5pmFTMMdLEVIudSb0Vvujtsf9gnhT4a8M+GfB9LJMvrwpYTCx5pzlKMeaW86lSV9XJ6votkrJI5G9ubdoZJYrZIUVgrMvCcg4z7nB/KuXvNXsrZWbf50n8Krz+Zr+8P4Pf8EUv2f/AAr+wf4k/ZT+I1nbaz8QvE0ceseIPF9vCv2m111FPkTWbMCVhty2xE/iUvu/1jV/GV+03+xx8ZP2RPip4g+F/wAZPBusafe2tw4sdTW3f7BrduCdlxazY2ujDBK53IThgCK9fing3GZbSp1qkbxmtbL4X2Z+KfR4+nfwz4lZtmGRZHONCthptU3Vl/GpLT2sE7dd4atRcZPfT7C/4JK/8FDNZ/YU+N0Uvi66u7z4B+K5o7bxXY5ZhppJ2x6lCg/5aRDhwOXjyOqrX+hB4b8QaV4l8P6T4j0PVLDWtEvreO8sbu1kEkV1A6hkkjYcMrKwIPvX+VEbefhRbzf98mv6r/8Ag37/AG/fE82pRfsJ/EiPWdXsFt7jUvA+pNG8v9nxRqXnsJm/hiA3PETwp3J/dFfYeE3GFSnUWV4m/LL4X2fb0fQ/if8AapfQ+wWYZfLxK4blF4qhFfWoJr95BKyrLX44fb/mhrvHX8s/hd/wTw/4Lr/8EY/+Chv7U/x4/YW/ZW+GX7ZPwr+I1zqUNvd3epW4hl06e/N7AJ4GvLW5trqJiFb70bfNgsCCP0u/4LRfsU/8FRP+CqX/AASN/Y18G6h+z14Rs/22IPGsPijx74R03WrKxstDRbTUYAIZri6aNsCe1yomc5c88Gv66wcgGlr+iD/npTPg79hb4N/En4Lf8E2/2WfgH8RdAi0T4s+GfhHovhbWNNjuo51ttTg0uOCSFZkJRwJFI3qSp6g4r+e//g2D/wCCUP7Z3/BPe6/bt0/9tb4Nab4A0Px5BoFvpMa69YammqRQnURcowtZZNg23UQ+fbnecDg1/YDRQB/Bh4M/4JRf8Fq/+CF/7WHxm+K//BJbwl8PP2vP2VPGkqtdeDtav4IblbVJZHtre8tpp7Z/tFt50iJdW0p3o53qN2wfsP8AsW/tR/8ABxb8fP2nvhJbftT/ALBP7PX7Jv7JMF1cv40vY9WiutYuoPss3lJar/aE7A+f9nziL7u7mv6SKKAP5Gf+Dmj/AIJCftlft5eKP2Uf2of2J9J0Dx/8R/hrDd2d74VuL6CyublGuobqC6tJLlkhkKSROrxMykgqVycivvD/AIJl/tF/8FtP2hvEXxd8Pf8ABSn9if4W/syfDq18FNDoOoaLcRm717XmdUKvGL+62RmIyt91FDYG7nFfvtRQB/IB/wAGwX/BKn9tb/gndrX7dI/bL+DumfDzSPHMWgQ6LGuuWOqJqKQPqH2hWFrLJsAW6i+/jduOBwa+Jov+CPX/AAWK/wCCJv7a/wAVv2kf+CPnhrwB+09+zf4uZ47jwTrF/BFcxac07TR2F9azzWxka2YlYbu2m37WO5V3up/vYooA/ED/AIJd/tB/8FnPj58UPiNrf/BSP9jr4Rfsk/BW10GOPwzZ6HfR3Oo6hrBuF3tNi9uXEQhMnVUG4DrX4yf8EDf+CT37e/7Gn/BWb9s39pf9pH4ET/Dn4K+LtD8UWeg6w2v6ZeG9lutftbqBfItriSWPdDDI+XVcYwcE4r+1qigD+DT/AIKu/wDBuD8f/wBqz/gtj4P+Pnwl+G1jqH7GvxC1bQdd+J+tR6raQHw/NG4i1RfsskizytPDbLKpiRwZLls4wa/Tz/g57/4J0/tV/t+fsg/sx/Bz9ir4Mp8R9e8L+Oxql1pcOqWOmJp2mJpdxboVa8mhQgNJGgVST7YBNf1H0UAfkL8FPhd+2V+zn/wRS+GPwd+E3g+00j9unwf8C7PRdB0W4msrqK18VW+mrHFA8kjm1kUTKBuLmM464r+avw5rH/B6Z4esrzRfDPwa+EvhS0vb251CeS3tfAiD7VcStLNM378/O8ju5ODyxr+86igD+A6H/g3m/wCC0/8AwVC+KfhPxz/wWS/bOsvDnwy0q486Pw/pOpQ6pfQo3Mken2NpHHptk7DCG4y7DjKOBiv7f/2a/wBnH4QfskfA74b/ALOnwG8J23gn4UeFdNTTdJ0+Nt7KgJZ5ZZDzJNI7PJJI3Lu7Mete5UUAFFFFADJPuNXG3Xh/Qdevpv7c0TSNZ2KNn2q2Sbb06bgcUUVNX4D3uGv99p/Mnj8A+BY1Cx+CvCSD/Z02Ef8AstXIPD+g6KHl0fRNI0mRuGa1tkiLD3KgZoorycP/ABEfXZ//AAahsSgeWvA/yayZtG0fWV2avpOm6qi/dW5t1lC/TcDiiivRxP8AD+Z8Fk3+9Q9H+hW/4QbwSOng7wt/4L4f/iaZF4Z8N6VfwXWl+H9E025+VfMt7SONsbum5QDRRXDQ/iL1PvMf/Bn6HVJ90U6iivVPzNBRRRQMKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigD/2Q==",
};

export const TemplateManger = {
  CHInitialEvaluation1_0: 41,
  CHInitialEvaluation2_0: 52,
  CHInitialEvaluation2_1: 53,
  CHFollowUp1_0: 54,
  CHFollowUp2_0: 55, //Develoepd
  CHFollowUp2_1: 56,
  CHReEvaluation1_0: 57,
  CHReEvaluation2_0: 58,
  CHReEvaluation2_1: 59,
  PTInitialEvaluation1_0: 60,
  PTInitialEvaluation2_0: 61,
  PTInitialEvaluation2_1: 62,
  PTFollowup1_0: 63,
  PTFollowup2_0: 64, //Develoepd
  PTFollowup2_1: 65,
  PTReevaluation1_0: 66,
  PTReevaluation2_0: 67,
  ACInitialEvaluation1_0: 69,
  ACInitialEvaluation2_0: 70,
  ACFollowupEvaluation1_0: 72,
  ACFollowupEvaluation2_0: 73,
  ACFollowupEvaluation2_1: 74,
  ACReevaluation1_0: 75,
  ACReevaluation2_0: 76,
  HBOTNotes1_0: 78,
  HBOTNotes2_0: 79,
  IMNotes2_0: 80,
  ORTHPNotes2_0: 81,
  PMSurgeryNotes2_0: 82,
  PMGeneralNotes2_1: 83,
  ANESGeneralNotes2_1: 84,
  ANESSurgeryNotes2_0: 85,
  OANotes2_0: 86,
  GSGNotes2_0: 87,
  MCNotes2_0: 88,
  CHFollowUp2_2: 90,
  CHReEvaluation2_2: 91,
  PMMedicalEvaluationNote2_2: 92,
  PMMedicalEvaluationNote2_2_1: 93,
  ROMNotes2_0: 94,
  IMInitialEvaluation2_1: 95,
  IMReEvaluation2_1: 97,
  IMESWT2_1: 98,
  CHInitialEvaluation2_2: 89,
  CHInitialEvaluation2_3: 100,
  CHInitialEvaluation2_4: 101,
  CHReEvaluation2_4: 102,
  PatientIntake: 103,
  CHReEvaluation2_3: 104,
  CHFollowUp2_3: 105,
  PMMedical2_3: 106,
  EMREvaluation: 107,
  PTMedicalEvalNotes2_2: 108,
  CHInitialEvaluation2_5: 109,
  CHReEvaluation2_5: 110,
  IMMedicalEvaluation: 111,
  NEUROTreatPlanProgReport: 112,
  NEUROProgressNote: 113,
  ACFollowupEvaluation2_2: 115,
  PMPostOperationReports: 116,
  PTMedicalEvaulation2_3: 117,
  IMMedicalEvaulation2_3: 118,
  PMMedical2_4: 122,
  PMMedical2_5: 126,
  PMMedicalEvaluationFollowUp2_5: 127,
  PMMedicalReevaluation: 128,
  PTInitialEvaluation2_5: 129,
  PMMedical2_6: 130,
  LMTMassageTherapistNotes2_0: 131,
  PTInititalEvaluation2_6: 132,
  PTFollowUpEvaluation2_6: 133,
  PTReEvaluation2_6: 134,
  IMMedicalEvaulation2_4: 135,
  PMMedical2_7: 136,
  PMOperativeTemplates1_0: 137,
  PMOperativeTemplates2_0: 140,
  PMOperativeTemplates3_0: 141,
  PsychoTherapyFU: 142,
  PsychoTherapyIE: 143,
  TriggerPointMedical: 144,
  PMOperativeTemplates4_0: 145,
  PMOperativeTemplates5_0: 146,
  PMOperativeTemplates6_0: 147,
  PMOperativeTemplates7_0: 148,
  PMMedical2_8: 149,
  ShockwaveIE: 150,
  ShockwaveFU: 151,
  ShockwaveRE: 152,
  BiowaveIE: 153,
  BiowaveFU: 154,
  BiowaveRE: 155,
  PTFollowUpEvaluation2_7: 156,
  PMOperativeTemplates8_0: 157,
  PMOperativeTemplates9_0: 158,
  PMOperativeTemplates10_0: 159,
  PMOperativeTemplates11_0: 160,
  PMOperativeTemplates12_0: 161,
  PMOperativeTemplates13_0: 162,
  PMOperativeTemplates14_0: 163,
  PMOperativeTemplates15_0: 164,
  PDPodiatricInitialEvaluation: 165,
  NEUROPSYCHOLOGICALReEVALUATION: 166,
  NEUROInitialEvaluation: 167,
  NeuroProgressNote1_0: 168,
  NEUROPSYCHOLOGICALASSESSMENT: 169,
  PDPodiatricFollowupEvaluation: 170,
  PDPodiatricReEvaluation: 171,
  PMMedical2_9: 172,
  EMGNote1_0: 173,
  NEUROProgressNote2_1: 174,
  CHInitialEvaluation2_7: 175,
  TMFlowReport: 176,
  ACInitial2_3: 177,
  ACFollowupEvaluation2_3: 178,
  ACReevaluation2_3: 179,
  PTInitial2_8: 181,
  CHInitialEvaluation2_8: 186,
  CHInitialEvaluation2_9: 187,
  OrthopedicEvaluation: 188,
  CHFollowupNotes2_8: 189,
  CHReEvaluationNotes2_8: 190,
  IMMedicalEvaluationNote2_5: 191,
  CHReEvaluation2_7: 192,
  BlankNote: 193,
  PTReevaluation2_8: 194,
  IMMedicalEvaluation2_6: 195,
  CHReEvaluationNotes2_9: 196,
  OperativeTemplate1_0: 197,
  FunctionalCapacityTest: 198,
  PTReEvaluation2_4: 121,
  PTFollowup2_4: 120,
  PTInitial2_4: 119,
  CHFollowup2_4: 125,
  CHInitialEvaluation2_6: 123,
  PTInitialEvaluation2_9: 182,
  PTFollowUpEvaluation2_9: 183,
  PTReEvaluation2_9: 184,
  PMMedical2_10: 180,
  CHInitialEvaluation2_10: 199,
  CHReEvaluationNotes2_10: 200,
  CHEvaluationNotes2_11: 201,
  PTEvaluationNotes2_10: 202,
  CHReEvaluationNotes2_11: 203
};

export const TransmitterType = {
  SelectType: "Select Type",
  D12s: "D12-s",
  F15: "F15",
  DI: "DI",
  T15: "15-T",
  R15: "R15",
  D20: "D20",
  C15: "C15",
  StandOff1: "Stand Off(1)",
  StandOff2: "Stand Off(2)",
  StandOff3: "Stand Off(3)",
};

export const RoleType = {
  Doctor: "Doctor",
  Patient: "Patient",
  Technician: "Technician",
  PA: "PA",
  CRNA: "CRNA",
  Other: "Other",
  Supervisor: "Supervisor",
  Attorney: "Attorney",
  SupervisingPhysician: "SupervisingPhysician",
  FrontDesk: "FrontDesk",
  Physician: "Physician",
  provider: 'Provider',
  Frontdesk: 'Front Desk',
  Admin: 'Admin',
  Interpreter: 'Interpreter',
  Practitioner: 'Practitioner'
};

export const SignType = {
  UPDATESIGNIMAGEPATHDOCTOR: "UPDATESIGNIMAGEPATHDOCTOR",
  UPDATESIGNIMAGEPATHPATIENT: "UPDATESIGNIMAGEPATHPATIENT",
  UPDATESIGNIMAGEPATHTECHNICIAN: "UPDATESIGNIMAGEPATHTECHNICIAN",
  UPDATESIGNIMAGEPATHINTERPRETER: "UPDATESIGNIMAGEPATHINTERPRETER",
  UPDATESIGNIMAGEPATHSUPERVISING: "UPDATESIGNIMAGEPATHSUPERVISING",
  GETSupervisingPhysicianSignature: "GETSupervisingPhysicianSignature",
  GETPatientSignature: "GETPatientSignature",
  GETDoctorSignature: "GETDoctorSignature"
};

export const DEAShcheduleToolTip = {
  ScheduleI: "Schedule I drugs, substances, or chemicals are defined as drugs with no currently accepted medical use and a high potential for abuse",
  ScheduleII: "Schedule II drugs, substances, or chemicals are defined as drugs with a high potential for abuse, with use potentially leading to severe psychological or physical dependence.",
  ScheduleIII: "Schedule III drugs, substances, or chemicals are defined as drugs with a moderate to low potential for physical and psychological dependence.",
  ScheduleIV: "Schedule IV drugs, substances, or chemicals are defined as drugs with a low potential for abuse and low risk of dependence.",
  ScheduleV: "Schedule V drugs, substances, or chemicals are defined as drugs with lower potential for abuse than Schedule IV and consist of preparations containing limited quantities of certain narcotics.",
  ScheduleVI: "Schedule VI drugs, substances, or chemicals are DEA unspecified or when a drug has no specified DEA schedule.",
};

export const DEAScheduleType = {
  ScheduleII: "C48675",
  ScheduleIII: "C48676",
  ScheduleIV: "C48677",
  ScheduleV: "C48679",
  ScheduleVI: "C38046",
};

export const OAForm = {
  REVISED_OSWESTRY_BACK: "REVISED OSWESTRY BACK PAIN DISABILITY QUESTIONNAIRE",
  ROLAND: "ROLAND MORRIS QUESTIONNAIRE",
  NECK: "NECK DISABILITY INDEX QUESTIONNAIRE",
  HEADACHE: "HEADACHE DISABILITY INDEX",
  SHOULDER: "SHOULDER PAIN AND DISABILITY INDEX (SPADI)",
  SUBJECTIVE: "SUBJECTIVE KNEE SCORE QUESTIONNAIRE",
  THE_UPPER_EXTREMITY: "THE UPPER EXTREMITY FUNCTIONAL INDEX (UEFI)",
};

export const PatientIntakeRequestType = {
  IntakeRequest: "Intake Request",
  OAFormsRequest: "OA Form Request",
};

export const MixPanelConstants = {
  AddVisit: "AddVisit",
  SelectVisitType: "SelectVisitType",
  SelectNoteTemplate: "SelectNoteTemplate",
  FetchNotesData: "FetchNotesData",
  SaveNotesDataRequestInitiated: "SaveNotesDataRequestInitiated",
  SaveNotesData: "SaveNotesData",
  SaveProcedureCode: "SaveProcedureCode",
  SaveDiagnosisCode: "SaveDiagnosisCode",
  SavePatientSign: "SavePatientSign",
  SaveDoctorSign: "SaveDoctorSign",
  GetDoctorSign: "GetDoctorSign",
  GetPatientSign: "GetPatientSign",
  GetOtherSign: "GetOtherSign",
  GetInterpreterSign: "GetInterpreterSign",
  SaveInterpreterSign: "SaveInterpreterSign",
  SaveOtherSign: "SaveOtherSign",
  DeletePatientSign: "DeletePatientSign",
  DeleteInterpreterSign: "DeleteInterpreterSign",
  DeleteDoctorSign: "DeleteDoctorSign",
  DeleteOtherSign: "DeleteOtherSign",
  FinalizeVisit: "FinalizeVisit",
  UnfinalizeVisit: "UnfinalizeVisit",
  BulkFinalizeVisits: "BulkFinalizeVisits",
  BulkUnfinalizeVisits: "BulkUnfinalizeVisits",
  DeleteVisits: "DeleteVisits",
  EPrescription: "EPrescription",
  EPrescriptionHistory: "EPrescriptionHistory",
  ViewNote: "ViewNote",
  SearchPatient: "SearchPatient",
  AddNewPatient: "AddNewPatient",
  ArchivePatients: "ArchivePatients",
  ViewArchivedPatients: "ViewArchivedPatients",
  CaseDetails: "CaseDetails",
  SendMessage: "SendMessage",
  ViewMessages: "ViewMessages",
  DocumentManager: "DocumentManager",
  IntakeSheets: "IntakeSheets",
  MedicalHistory: "MedicalHistory",
  AddAppointment: "AddAppointment",
  ViewNotes: "ViewNotes",
  AddNotes: "AddNotes",
  AddReminder: "AddReminder",
  EligibilityBenefits: "EligibilityBenefits",
  SurgeryCenterForms: "SurgeryCenterForms",
  OtherDocuments: "OtherDocuments",
  ReferPatient: "ReferPatient",
  EPrescription: "EPrescription",
  RequestIntakeSheets: "RequestIntakeSheets",
  CheckInPatient: "CheckInPatient",
  ToggleShowAllPatients: "ToggleShowAllPatients",
  ChangeDayView: "ChangeDayView",
  ChangeWeekView: "ChangeWeekView",
  ChangeMonthView: "ChangeMonthView",
  ChangeAgendaView: "ChangeAgendaView",
  SelectToday: "SelectToday",
  NavigatePrevious: "NavigatePrevious",
  NavigateNext: "NavigateNext",
  SelectDate: "SelectDate",
  SelectLocation: "SelectLocation",
  ToggleBusinessHours: "ToggleBusinessHours",
  ToggleSelectAllDoctors: "ToggleSelectAllDoctors",
  ToggleDoctor: "ToggleDoctor",
  OpenColorPicker: "OpenColorPicker",
  OpenMultipleVisits: "OpenMultipleVisits",
  OpenUpdateSchedule: "OpenUpdateSchedule",
  OpenDoctorFilter: "OpenDoctorFilter",
  UpdateLocation: "UpdateLocation",
  ToggleSignatureOnFile: "ToggleSignatureOnFile",
  ToggleSignaturePad: "ToggleSignaturePad",
  SelectLocation: "SelectLocation",
  UpdateLocation: "UpdateLocation",
  UpdateAppointment: "UpdateAppointment",
  ChangeVisitType: "ChangeVisitType",
  ChangeVisitStatus: "ChangeVisitStatus",
  ChangeDoctor: "ChangeDoctor",
  ChangeVisitNotes: "ChangeVisitNotes",
  SelectTimeSlot: "SelectTimeSlot",
  ClickUpdateAppointmentButton: "ClickUpdateAppointmentButton",
  PrintPatient: "PrintPatient",
  UpdatePatient: "UpdatePatient",
  UpdateAndClosePatient: "UpdateAndClosePatient",
  SelectPatientTab: "SelectPatientTab",
  SelectInsuranceTab: "SelectInsuranceTab",
  SelectAccidentTab: "SelectAccidentTab",
  SelectAttorneyTab: "SelectAttorneyTab",
  SelectReferringOfficeTab: "SelectReferringOfficeTab",
  SelectEmergencyContactTab: "SelectEmergencyContactTab",
  SelectEmployerTab: "SelectEmployerTab",
  SelectDocumentManagerTab: "SelectDocumentManagerTab",
  OpenMessagesModal: "OpenMessagesModal",
  SubmitMessage: "SubmitMessage",
  SelectTreeItem: "SelectTreeItem",
  SearchPatient: "SearchPatient",
  ExpandAll: "ExpandAll",
  SendFax: "SendFax",
  SendEmail: "SendEmail",
  MergeFiles: "MergeFiles",
  ScanDocument: "ScanDocument",
  UploadDocument: "UploadDocument",
  SaveIntakeForm: "SaveIntakeForm",
  PrintIntakeForm: "PrintIntakeForm",
  SaveAndPrintPDF: "SaveAndPrintPDF",
  SelectNoteType: "SelectNoteType",
  AddNewNotes: "AddNewNotes",
  DeleteNotes: "DeleteNotes",
  AssignUsers: "AssignUsers",
  AssignRoles: "AssignRoles",
  SelectReminderType: "SelectReminderType",
  SelectPatientName: "SelectPatientName",
  AssignUsers: "AssignUsers",
  SelectStartDate: "SelectStartDate",
  AddReminder: "AddReminder",
  SaveReferral: "SaveReferral",
  SaveAndPrintReferral: "SaveAndPrintReferral",
  FormFieldChange: "FormFieldChange",
  SavePatientData: "SavePatientData",
  SelectPatient: "SelectPatient",
  AddEditMedicalNarrative: "AddEditMedicalNarrative",
  UpdatePainLevelBeforeTx: "UpdatePainLevelBeforeTx",
  UpdatePainLevelAfterTx: "UpdatePainLevelAfterTx",
  UpdateAcupuncturePoints: "UpdateAcupuncturePoints",
  UpdateDoctorPoints: "UpdateDoctorPoints",
  SelectAcupunctureMethod: "SelectAcupunctureMethod",
  UpdatePatientReported: "UpdatePatientReported",
  UpdatePainGrade: "UpdatePainGrade",
  UpdateAcupunctureTreatment: "UpdateAcupunctureTreatment",
  UpdateElectroAcupunctureTreatment: "UpdateElectroAcupunctureTreatment",
  UpdateMoxaTreatment: "UpdateMoxaTreatment",
  UpdateCuppingTreatment: "UpdateCuppingTreatment",
  UpdateIntermittentPain: "UpdateIntermittentPain",
  UpdateCuppingTherapyArea: "UpdateCuppingTherapyArea",
  UpdateProcedureDuration: "UpdateProcedureDuration",
  UpdateObjectiveCondition: "UpdateObjectiveCondition",
  UpdateAssessmentTolerance: "UpdateAssessmentTolerance",
  UpdatePlanContinueTherapy: "UpdatePlanContinueTherapy",
  SelectProcedureCode: "SelectProcedureCode",
  SelectBodyPart: "SelectBodyPart",
  UpdateComplaint: "UpdateComplaint",
  UpdateWorkStatus: "UpdateWorkStatus",
  UpdateJobTitle: "UpdateJobTitle",
  UpdateJobDescription: "UpdateJobDescription",
  UpdateWorkStatusRadio: "UpdateWorkStatusRadio",
  UpdateMissedWorkDate: "UpdateMissedWorkDate",
  UpdateCanGoWorkDate: "UpdateCanGoWorkDate",
  SelectAcupunctureMethod: "SelectAcupunctureMethod",
  ClickBack: "ClickBack",
  ShowPopupNotes: "ShowPopupNotes",
  ViewMedicalHistory: "ViewMedicalHistory",
  ViewTagPage: "ViewTagPage",
  SelectPatientReported: "SelectPatientReported",
  TogglePatientTreated: "TogglePatientTreated",
  AddProcedureCode: "AddProcedureCode",
  AddProcedureCodeWithBodyPart: "AddProcedureCodeWithBodyPart",
  ToggleProcedureCode: "ToggleProcedureCode",
  ToggleBodyPart: "ToggleBodyPart",
  DeleteCodeBodyPart: "DeleteCodeBodyPart",
  SaveProcedureCodeSelection: "SaveProcedureCodeSelection",
  ToggleComplaint: "ToggleComplaint",
  ShowComplaintMaster: "ShowComplaintMaster",
  ClickDoctorSign: "ClickDoctorSign",
  ClickPatientSign: "ClickPatientSign",
  ClickDiagnosisCode: "ClickDiagnosisCode",
  ClickSave: "ClickSave",
  ClickSaveFinalize: "ClickSaveFinalize",
  ClickUnfinalize: "ClickUnfinalize",
  TextBoxInput: "TextBoxInput",
  RomTextBoxInput: "RomTextBoxInput",
  CheckBoxChange: "CheckBoxChange",
  RadioButtonChange: "RadioButtonChange",
  SliderPainLevelChange: "SliderPainLevelChange",
  DisableCheckboxChange: "DisableCheckboxChange",
  ClickPlanTextBox: "ClickPlanTextBox",
  ClickAssessmentTextBox: "ClickAssessmentTextBox",
  AddMissingNotes: "AddMissingNotes",
  UltrasoundImageDeleted: "UltrasoundImageDeleted",
  SendIntakeRequest: "SendIntakeRequest",
};

export const MixPanelForCaseConstants = {
  AddedNewPatient: "AddedNewPatient",
  PatientInfoUpdate: "PatientInfoUpdate",
  PatientSpecificInfoUpdate: "PatientSpecificInfoUpdate"
};

export const LogLevel = {
  TRACE: "TRACE",
  DEBUG: "DEBUG",
  INFO: "INFO",
  WARN: "WARN",
  ERROR: "ERROR",
  FATAL: "FATAL"
};

export const MixPanelForButtonConstantsClicks = {
  SearchAppointments: "SearchAppointments",
  ProcedureCode: "ProcedureCode",
  MedicalHistory: "MedicalHistory",
  DiagnosisCode: "DiagnosisCode",
  DoctorSign: "DoctorSign",
  PatientSign: "PatientSign",
  FUNotesClicked: "FUNotesClicked",
  RENotesClicked: "RENotesClicked",
  IENotesClicked: "IENotesClicked",
  OtherSign: "OtherSign",
  TemplateClick: "TemplateClick",
  AddAppointment: "AddAppointment",
  UpdateProcedureCode: "UpdateProcedureCode",
  UpdateDiagnosisCode: "UpdateDiagnosisCode",
  SaveNote: "SaveNote",
  UnFinalizeNote: "UnFinalizeNote",
  Login: "Login",
  SearchPatientButton: "SearchPatientButton",
  ArchiveButton: "ArchiveButton",
  UnArchiveButton: "UnArchiveButton",
  AddNewPatientButton: "AddNewPatientButton",
  Slot15Min: "Slot15Min",
  Slot30Min: "Slot30Min",
  Slot45Min: "Slot45Min",
  Slot60Min: "Slot60Min",
  SelectVisitStatus: "SelectVisitStatus",
  SelectDateRange: "SelectDateRange",
  SelectCaseType: "SelectCaseType",
  SelectSortBy: "SelectSortBy",
  ExportToExcel: "ExportToExcel",
  ViewArchivedVisits: "ViewArchivedVisits",
  UnArchiveVisit: "UnArchiveVisit",
  ViewCaseDetails: "ViewCaseDetails",
  ViewIntakeSheets: "ViewIntakeSheets",
  EligibilityCheck: "EligibilityCheck",
  RequestOANotes: "RequestOANotes",
  AddEditMedicalNarrative: "AddEditMedicalNarrative",
  ViewMedicalNarrative: "ViewMedicalNarrative",
  DeleteMedicalNarrative: "DeleteMedicalNarrative",
  NavigateMedicalNarrative: "NavigateMedicalNarrative",
  ErrorMedicalNarrative: "ErrorMedicalNarrative",
  UploadDocuments: "UploadDocuments",
  CheckOut: "CheckOut",
  ProviderSign: "ProviderSign",
  SelectProvider: "SelectProvider",
  SaveAndFinalizeNotes: "SaveAndFinalizeNotes",
  UnfinalizeNotes: "UnfinalizeNotes",
  AddProcedureCodeOnly: "AddProcedureCodeOnly",
  AddProcedureCodeWithBodyPart: "AddProcedureCodeWithBodyPart",
  AddProcedureCode: "AddProcedureCode",
  DeleteCodeBodyPart: "DeleteCodeBodyPart",
  DiagnosisCode: "DiagnosisCode",
  AddComplaint: "AddComplaint",
  BackClick: "BackClick",
  TagButton: "TagButton",
  DeleteCodeBodyPart: "DeleteCodeBodyPart",
  ToggleProcedureRow: "ToggleProcedureRow",
  ToggleBodyPartRow: "ToggleBodyPartRow",
  ToggleComplaintRow: "ToggleComplaintRow",
  RadioChange: "RadioChange",
  CheckBoxChange: "CheckBoxChange",
  ProcedureCodeCheck: "ProcedureCodeCheck",
  BodyPartCheck: "BodyPartCheck",
  SaveProcedureCode: "SaveProcedureCode",
  DiagnosisCodeClick: "DiagnosisCodeClick",
  AddBodyPartTable: "AddBodyPartTable",
  RemoveBodyPartTable: "RemoveBodyPartTable",
  ApplyTag: "ApplyTag",
  DeleteUltrasoundImage: "DeleteUltrasoundImage",
  PayorModalOpen: "PayorModalOpen",
  PayorSearch: "PayorSearch",
  PayorSave: "PayorSave",
  CoverageLookUpModal: "CoverageLookUpModal",
  CheckAvality: "CheckAvality"
};

export const pageTitleData = [
  { index: 1, title: 'DASHBOARD' },
  { index: 2, title: 'APPOINTMENTS' },
  { index: 3, title: 'PATIENTS' },
  { index: 4, title: 'MY CALENDAR' },
  { index: 5, title: 'DOCUMENT SEARCH' },
  { index: 6, title: 'E-PRESCRIPTION HISTORY' },
  { index: 7, title: 'INTAKE HISTORY' },
  { index: 8, title: 'OFFICE CALENDAR' },
  {
    index: 29, title: 'Practice Setup', subMenuIndex: null, subMenuItems: [
      { index: 11, title: 'Adjuster', link: '/AdjusterMaster' },
      { index: 12, title: 'Insurance Company', link: '/InsuranceMaster' },
      { index: 13, title: 'Complaint', link: '/ComplaintMaster' },
      { index: 19, title: 'Referring Office', link: '/ReferringOffice' },
      { index: 20, title: 'Attorney Master', link: '/AttorneyMaster' },
      { index: 21, title: 'Referring Doctor', link: '/ReferringDoctor' },
      { index: 22, title: 'Location', link: '/Location' },
      { index: 23, title: 'Provider', link: '/Provider' },
      { index: 24, title: 'Doctor', link: '/Doctor' },
      { index: 27, title: 'Transportation', link: '/Transport' },
      { index: 28, title: 'Reminder Type', link: '/Reminder' },
      { index: 35, title: 'Re-eval Configuration', link: '/ReEvalConfiguration' },
      { index: 29, title: 'User', link: '/User' },
    ]
  },
  {
    index: 30, title: 'Reports', subMenuIndex: null, subMenuItems: [
      { index: 14, title: 'Visit Report', link: '/VisitReport' },
      { index: 15, title: 'UnSent NF2 Report', link: '/UnSentNF2Report' },
      { index: 16, title: 'Message Report', link: '/MessageReport' },
      { index: 25, title: 'Transportation Report', link: '/TransportationReport' },
      { index: 26, title: 'Daily Schedule Report', link: '/DailyScheduleReport' },
      { index: 9, title: 'Referral List', link: '/ReferralList' },
      { index: 33, title: 'Patient Visit Analysis ', link: '/analysisVisitReports' },
      { index: 17, title: 'Patient Absentee Report', link: '/PatientAbsenteeReport' },
      { index: 36, title: 'Patient Visit Summary Report', link: '/PatientVisitSummaryReport' },
      { index: 10, title: 'APTP Report', link: '/APTPReport' },
    ]
  },
  { index: 32, title: 'APPOINTMENTS' },
  { index: 31, title: 'Assigned reports' },
  {
    index: 38, title: 'Practice Setup', subMenuIndex: null, subMenuItems: [
      { index: 37, title: 'Re-eval Configuration', link: '/ReEvalConfiguration' },
    ]
  },
  {
    index: 34, title: 'Reports', subMenuIndex: null, subMenuItems: [
      { index: 10, title: 'APTP Report', link: '/APTPReport' },
    ]
  },

];

export const SpineTime = {
  txtPatientSignDate: "PatientSignatureDate",
  txtChiroSignDate: "ChiropractorSignatureDate",
  txtPatientName: "PatientName",
  signPatientSign: "PatientSignature",
  signChiroSign: "ChiropractorSignature",
  txtProviderName: 'ProviderName',
  txtProviderAddress: 'ProviderAddress',
};

export const PatientAcknowledgmentConsentValues = {
  txtPatientSignDate: "PatientSignatureDate",
  txtPatientDescription: "PatientDescription",
  txtPatientName: "PatientName",
  signPatientSign: "PatientSignature",
  txtPatientDescription: "PatientDescription",
  txtProviderName: 'ProviderName',
  txtEffectiveDate: 'EffectiveDate',
}

export const IntakeFormWithBodyPartValues = {
  txtPatientSignDate: "PatientSignatureDate",
  txtPatientDescription: "PatientDescription",
  txtPatientName: "PatientName",
  signPatientSign: "PatientSignature",
  signProviderSign: "ProviderSignature",
  txtPatientDescription: "PatientDescription",
  txtProviderName: 'ProviderName',
  txtEffectiveDate: 'EffectiveDate',
  txtEmergencyRelationship: 'EmergencyRelationship',
  txtDetailOfAccident: 'DetailOfAccident',
  txtInjuriesCaseEstablished: 'InjuriesCaseEstablished',
  txtInsuredDOB: 'InsuredDOB',
  txtReasonForVisit: 'ReasonForVisit',
  txtDateOfSymptom: 'DateOfSymptom',
  txtInjuryHistory: 'InjuryHistory',
  txtMedications: 'Medications',
  txtMedicationAllergies: 'MedicationAllergies',
  bodyPartImage: 'BodyPartImage',
}

export const AzureSpeechServiceConst = {
  // Azure Key & Region
  AZURE_KEY: "2oucTVipJ7uebT1T1bYNG8FcSNIL3oDK5MTbZToAorj2k9QZHJ6rJQQJ99BFACYeBjFXJ3w3AAAYACOGZdrg",
  AZURE_REGION: "eastus" // e.g. "eastus" or "centralindia"
}

export const ReEvalMessage = "Patient has re-evaluation pending. Would you like to mark appointment as re-evaluation visit or "

export const EnumEntity = {
  USER: 0,
  CASE: 1,
  VISIT: 2,
  BILL: 3,
  MASTER: 4,
  REPORT: 5,
  MASTER_DOCTOR: 6,
  MASTER_PROVIDER: 7,
  Notes: 8,
  PDFView: 9,
  MASTER_LOCATION: 10,
  MASTER_REF_DOCTOR: 11,
  MASTER_READDING_DOCTOR: 12,
  MASTER_BILLING_DOCTOR: 13,
  MASTER_REF_OFFICE: 14,
  MASTER_PROCEDURE: 15,
  MASTER_TEMPLATE: 16,
  SYSTEM_SETTING: 17,
  MASTER_INSURANCE: 18,
  MASTER_Provider1500FormConfiguration: 19,
  SPECIALITY: 20
};

export const VisitSummaryReport = {
  VisitFromDate: "VisitFromDate",
  VisitToDate: "VisitToDate",
  VisitSearchResultList: "VisitSearchResultList",
  VisittotalNoRowsReturn: "VisittotalNoRowsReturn",
  VisitSearchParameter: "VisitSearchParameter",
  VisitCaseTypeValue: "VisitCaseTypeValue",
  VisitCaseStatus: "VisitCaseStatus",
  VisitSpeciality: "VisitSpeciality",
  VisitAccidentFromDate: "VisitAccidentFromDate",
  VisitAccidentToDate: "VisitAccidentToDate",
  VisitOpenedFromDate: "VisitOpenedFromDate",
  VisitOpenedToDate: "VisitOpenedToDate",
  visitAppointment: "visitAppointment",
}